import { render, staticRenderFns } from "./GeneralEventDetail.vue?vue&type=template&id=a01a362a&"
import script from "./GeneralEventDetail.vue?vue&type=script&lang=js&"
export * from "./GeneralEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports